const my_profile = {
  viewMyClubSeacretProfile: "मेरी क्लबसीक्रेट प्रोफ़ाइल देखें", // translated 
  viewMoreDetails: "अधिक विवरण देखें", // translated 
  verifiedEmail: "सत्यापित ईमेल", // translated 
  unverifiedEmail: "अपुष्ट ईमेल", // translated 
  balance: "संतुलन", // translated 
  pointsIn: "अंक", // translated 
  pointsOut: "बताता है", // translated 
  topUp: "लबालब भरना", // translated 
  pointsHistoryTable: "अंक इतिहास तालिका", // translated 
  createdFrom: "से निर्मित", // translated 
  createdTo: "बनाया गया", // translated 
  selectStatus: "स्थिति का चयन करें...", // translated 
  searchByTitle: "शीर्षक के आधार पर खोजें...", // translated 
  offerStatus: "प्रस्ताव की स्थिति", // translated 
  selectOfferStatus: "सभी", // translated 
  quotationSent: "कोटेशन भेजा गया", // translated 
  offerInProgress: "प्रस्ताव प्रक्रियाधीन है", // translated 
  offerAvailable: "ऑफर उपलब्ध है", // translated 
  offerAccepted: "प्रस्ताव स्वीकृत है", // translated 
  offerExpired: "ऑफर की समय सीमा समाप्त हो गई है।", // translated 
  offerReference: "प्रस्ताव संदर्भ", // translated 
  tripStartDate: "यात्रा प्रारंभ तिथि", // translated 
  dueDate: "नियत तारीख", // translated 
  viewOffer: "ऑफ़र देखें", // translated 
  notApplicable: "लागू नहीं", // translated 
  manageSubscription: "सदस्यता प्रबंधित करें", // translated 
  logoAndColors: "लोगो और रंग", // translated 
  editColors: "रंगों को संपादित करें", // translated 
  editLogo: "लोगो संपादित करें", // translated 
  primaryColor: "प्राथमिक रंग", // translated 
  secondaryColor: "द्वितीयक रंग", // translated 
  subagentLogoAlt: "उप-एजेंट लोगो", // translated 
  pickColors: "रंग चुनें", // translated 
  logoPreview: "लोगो का पूर्वावलोकन", // translated 
  logoPreviewAlt: "लोगो का पूर्वावलोकन", // translated 
  noLogoSelected: "कोई लोगो चयनित नहीं", // translated 
  changeLogo: "लोगो बदलें", // translated 
  uploadLogo: "लोगो अपलोड करें", // translated 
  supportedImageFormats: "समर्थित प्रारूप: जेपीजी, पीएनजी। अधिकतम आकार: 2 एमबी", // translated 
  saving: "सहेजा जा रहा है...", // translated 
  logoUpdatedSuccess: "लोगो सफलतापूर्वक अपडेट हो गया", // translated 
  failedToUpdateLogo: "लोगो अपडेट करने में विफल", // translated 
  colorsUpdatedSuccess: "रंग सफलतापूर्वक अपडेट हो गए हैं", // translated 
  failedToUpdateColors: "रंगों को अपडेट करने में विफल रहा", // translated 
  selectImageFile: "कृपया एक छवि फ़ाइल चुनें", // translated 
  imageSizeLimit: "छवि का आकार 5MB से कम होना चाहिए।", // translated 
  pushNotifications: "सूचनाएं धक्का", // translated 
  pushNotificationsDescription: "महत्वपूर्ण अपडेट और घटनाओं के लिए ब्राउज़र सूचनाएं प्राप्त करें", // translated 
  pushNotificationsNotSupported: "इस ब्राउज़र में पुश नोटिफिकेशन समर्थित नहीं हैं।", // translated 
  pushNotificationsDeniedMessage: "सूचना प्राप्त करने की अनुमति नहीं दी गई। कृपया पुश नोटिफिकेशन प्राप्त करने के लिए अपने ब्राउज़र की सेटिंग में नोटिफिकेशन चालू करें।", // translated 
  pushNotificationsEnabled: "पुश नोटिफिकेशन सफलतापूर्वक सक्षम हो गए हैं।", // translated 
  pushNotificationsDisabled: "पुश नोटिफिकेशन सफलतापूर्वक अक्षम कर दिए गए हैं।", // translated 
  userInformationMissing: "उपयोगकर्ता की जानकारी उपलब्ध नहीं है", // translated 
  failedToUpdatePushNotifications: "पुश नोटिफिकेशन सेटिंग्स को अपडेट करने में विफल।", // translated 
  notificationPermissionDenied: "सूचना प्राप्त करने की अनुमति नहीं दी गई। कृपया इसे अपने ब्राउज़र की सेटिंग में सक्षम करें।", // translated 
  notificationPermissionRequired: "पुश नोटिफिकेशन चालू करने के लिए नोटिफिकेशन की अनुमति आवश्यक है।", // translated 
  notSupported: "समर्थित नहीं", // translated 
  permissionDenied: "अनुमति नहीं मिली", // translated 
  permissionNotRequested: "अनुमति का अनुरोध नहीं किया गया", // translated 
  enabled: "सक्रिय", // translated 
  disabled: "अक्षम", // translated 
};


export default my_profile;
